

import { BarHorizontalCustomComponent } from './components/ngx-charts-polar-charts-custom/bar-horizontal.component';
import { YAxisTicksCustomComponent } from './components/ngx-charts-polar-charts-custom/y-axis-ticks.component';
import { YAxisCustomComponent } from './components/ngx-charts-polar-charts-custom/y-axis.component';
import { ChartComponent } from './components/ngx-charts-polar-charts-custom/chart.component';
import { PieLabelCustomComponent } from './components/ngx-charts-polar-charts-custom/pie-label.component';
import { PolarChartCustomComponent } from './components/ngx-charts-polar-charts-custom/polar-chart.component';
import { AppDateAdapter } from './service/date.adapter';
import { DatexPipe } from './pipes/datex.pipe';
// import { EditProfileComponent } from './components/top-bar/components/edit-profile/edit-profile.component';
// import { TopBarComponent } from './components/top-bar/top-bar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {A11yModule} from '@angular/cdk/a11y';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {OverlayModule} from '@angular/cdk/overlay';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {NgDynamicBreadcrumbModule} from "ng-dynamic-breadcrumb";
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { TranslateModule } from '@ngx-translate/core';
import { BixComfirmModule } from './components/bix-comfirm/bix-comfirm.module';
import { NouisliderModule } from 'ng2-nouislider';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ClickOutsideModule } from 'ng-click-outside';
import { SeriesHorizontalComponent } from './components/ngx-charts-polar-charts-custom/chart-series-horizontal-component';
import { BarLabelComponent } from './components/ngx-charts-polar-charts-custom/charts-bar-label-component';
import { SvgLinearGradientComponent } from './components/ngx-charts-polar-charts-custom/charts-svg-linear-gradient-custom.component';
import { BarComponentCustom } from './components/ngx-charts-polar-charts-custom/chart-bar-custom';
import { AdvancedPieChartDialogComponent } from './components/advanced-pie-chart/advanced-pie-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SpellcheckDirective } from './directives/auto-spellcheck/spellcheck.directive';
import { TextareaSpellcheckDirective } from './directives/auto-spellcheck/textareaspellcheck.directive';
import { MfaConfirmDialogComponentComponent } from './components/mfa-confirm-dialog-component/mfa-confirm-dialog-component.component';

@NgModule({
  declarations: [DatexPipe, PolarChartCustomComponent,BarHorizontalCustomComponent, PieLabelCustomComponent, ChartComponent,YAxisTicksCustomComponent,YAxisCustomComponent, SeriesHorizontalComponent, BarLabelComponent, SvgLinearGradientComponent, BarComponentCustom, AdvancedPieChartDialogComponent,
    SpellcheckDirective, TextareaSpellcheckDirective, MfaConfirmDialogComponentComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    NouisliderModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxChartsModule,
    MatTooltipModule,
    NgApexchartsModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    TranslateModule  ],
  exports: [
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    NgDynamicBreadcrumbModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    NgxMatSelectSearchModule,
    DatexPipe,
    TranslateModule,
    BixComfirmModule,
    NouisliderModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxChartsModule,
    ClickOutsideModule,
    PolarChartCustomComponent,
    BarHorizontalCustomComponent,
    PieLabelCustomComponent,
    ChartComponent,
    YAxisTicksCustomComponent,
    YAxisCustomComponent,
    SeriesHorizontalComponent,
    BarLabelComponent,
    SvgLinearGradientComponent,
    BarComponentCustom,
    AdvancedPieChartDialogComponent,
    NgApexchartsModule,
    MatFormFieldModule,
    SpellcheckDirective,
    TextareaSpellcheckDirective
  ],

  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {provide: DateAdapter, useClass: AppDateAdapter},
    DatexPipe,
  ],
})
export class SharedModule { }
